import { css } from 'lit'; export default css`:host {  --mds_core_table_transition-duration: 350ms;}`;